module.exports = __webpack_public_path__ + "img/mt.d8ce388c.svg";